import getBlockTemplateById from '../selectors/block-template-by-id';
import attributes from '../constants/attributes';
import { connectedStore } from '../../store';
import injectCssSources from '../../utils/inject-css-sources';
import injectJsSources from '../../utils/inject-js-sources';

const { BLOCK_TEMPLATE_DEPENDENCY_ATTRIBUTE } = attributes;

const injectDependencies = (liveDocument, blockTemplateId) => {
  if (liveDocument.querySelector(`[${BLOCK_TEMPLATE_DEPENDENCY_ATTRIBUTE}="${blockTemplateId}"]`)) {
    return;
  }

  const store = connectedStore.get();
  const state = store.getState();
  const blockTemplate = getBlockTemplateById(state, blockTemplateId);

  if (!blockTemplate || !blockTemplate.dependencies) return;

  const { css: cssDependencies, js: jsDependencies } = blockTemplate.dependencies;

  if (cssDependencies) {
    const element = liveDocument.head;
    const position = 'beforeend';

    injectCssSources(
      liveDocument,
      cssDependencies,
      {
        [BLOCK_TEMPLATE_DEPENDENCY_ATTRIBUTE]: blockTemplateId,
      },
      {
        element,
        position,
      }
    );
  }

  if (jsDependencies) {
    const element = liveDocument.body;
    const position = 'beforeend';

    injectJsSources(
      liveDocument,
      jsDependencies,
      {
        [BLOCK_TEMPLATE_DEPENDENCY_ATTRIBUTE]: blockTemplateId,
      },
      {
        element,
        position,
      }
    );
  }
};

export default injectDependencies;
